import React, { useEffect } from 'react';
//import { organismos } from '../../json/organismos';
import './organismos.css';

const Organismos = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

  return (
    <div className='container'>
        <div className='row'>
            <div>
                <h5 className='title'>Organismos descentralizados</h5>
                <hr className='hr-gob'/>
            </div>
            <div className='organismos'>
                {
                    window._my_organismos.map((item, index)=>(
                        <a href={item.url} target="_new" key={ index }>
                            <h3 className='title'>{item.nombre}</h3>
                            <p>{item.descripcion}</p>
                        </a>
                    ))
                }
            </div>
            <div id="mi_espacio"/>
        </div>
    </div>
  )
}

export default Organismos